import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from '../app.service';
import { GlobalService } from '../global/services/global.service';
import { WorkspaceService } from '../workspace/workspace.service';
import { ScreenDocumentList } from './screen-document-upload/screen-document';
import { ScreenVideo } from './screen-video-list/screen-video';
import { User } from './user';
import { UserService } from './user.service';

@Component({
    selector: 'gtw-screen-video-container',
    templateUrl: './screen-video-container.component.html',
    styleUrls: ['./screen-video-container.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ScreenVideoContainerComponent implements OnInit, OnDestroy {
  updateDocSelectedInput!: ScreenDocumentList;
  chidTabSelectedIndex!: number;

  childTabIndex: number = 0;

  updateScreenVideoInput!: ScreenVideo;
  refreshScreenVideoListOutput = false;

  refreshScreenDocumentOutput = false;

  private allowedRoles = ['admin', 'super admin', 'developer'];
  private readonly subs = new Subscription();

  constructor(
    public gtwGlobal: GlobalService,
    public gtwWorkspace: WorkspaceService,
    public gtwApp: AppService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const u = this.gtwApp.USER_SETTINGS?.user as User | undefined;
    if (u) {
      this.userService.setUser(u);
    }
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        if (!isNaN(this.clientKeyNum) && !isNaN(this.screenKeyNum)) {
          this.refreshScreenVideoList(true);
          this.refreshScreenDocumentList(true);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private activeScreen(): any {
    return this.gtwWorkspace.workspaceFactory?.activeScreen || {};
  }

  get screenKeyNum(): number {
    const a = this.activeScreen();
    const raw = a.link ?? a.screenKey ?? a.screen_key;
    return parseInt(String(raw), 10);
  }

  get clientKeyNum(): number {
    const raw =
      this.gtwGlobal.global?.globalParams?.client_key ?? this.gtwApp.USER_SETTINGS?.user?.client_key;
    return parseInt(String(raw), 10);
  }

  updateScreenVideo(video: ScreenVideo) {
    this.updateScreenVideoInput = video;
  }

  updateDocSelected(Document: ScreenDocumentList) {
    this.updateDocSelectedInput = Document;
    this.chidTabSelectedIndex = 1;
  }

  refreshScreenVideoList(event: boolean) {
    if (!isNaN(this.clientKeyNum) && !isNaN(this.screenKeyNum)) {
      this.refreshScreenVideoListOutput = event;
      setTimeout(() => {
        this.refreshScreenVideoListOutput = false;
      }, 300);
    }
  }

  refreshScreenDocumentList(event: boolean) {
    if (!isNaN(this.clientKeyNum) && !isNaN(this.screenKeyNum)) {
      this.refreshScreenDocumentOutput = event;
      setTimeout(() => {
        this.refreshScreenDocumentOutput = false;
      }, 300);
    }
  }

  isValidUser() {
    return this.userService.isValidUser(this.allowedRoles);
  }

  onTabChanged(event: any) {
    this.childTabIndex = event.index;
  }
}
